module.exports = __webpack_public_path__ + "img/_tortoise.ef46b684.svg";